<!--
Non-bootstrap version of Confirm.vue - intended to be a drop-in replacement.
bootstrap modals are breaking with $.... modal is not a function :-(

@author cm359n
-->
<template>
  <div>
    <NewModalPopup v-if="showConfirm" id="confirm" title="Confirm" displayAt="top">
      <p>{{ msg }}</p>
      <div class="w-100">
        <div class="btn-group w-100" role="group" aria-label="confirm buttons">
          <button type="button" class="btn btn-primary"
            @click="doOkCallback()">OK</button>
          <button type="button" class="btn btn-secondary"
            @click="doCancelCallback()">Cancel</button>
        </div>
      </div>
    </NewModalPopup>
  </div>
</template>

<script>
import NewModalPopup from '@/components/NewModalPopup.vue'

export default {
  name: 'NewConfirm',
  components: {
    NewModalPopup
  },
  methods: {
    // we should close this thing when ok/cancel are called
    // we don't get that for free with this non-bootstrap version
    doOkCallback () {
      this.showConfirm = false
      this.okCallback()
    },
    doCancelCallback () {
      this.showConfirm = false
      this.cancelCallback()
    },
    // Used by container components to show the dialogue.
    // As this is a global component, if callbacks are not defined they revert to noop.
    show (msg, okCallback, cancelCallback) {
      this.msg = msg
      if (okCallback) {
        this.okCallback = okCallback
      } else {
        this.okCallback = this.noop
      }
      if (cancelCallback) {
        this.cancelCallback = cancelCallback
      } else {
        this.cancelCallback = this.noop
      }
      /* so broken rn ... especially if your build reports bootstrap 5 apparently
         check with 'npm list bootstrap'

      let cm = $('#confirmModal').modal
      if (typeof cm === 'function') {
        $('#confirmModal').modal('show')
      } */
      this.showConfirm = true
    },
    // Default callback function called when the OK button is clicked.
    // Container components can override this.
    okCallback () {
      this.noop()
    },
    // Default callback function called when the Cancel button is clicked.
    // Container components can override this.
    cancelCallback () {
      this.noop()
    },
    // No op function for default/unspecified callbacks.
    noop () {
      console.log('noop')
    }
  },
  data () {
    return {
      msg: '',
      showConfirm: false
    }
  }
}
</script>
